(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["db-customer-stories"]) return;
  try {
    
(() => {
  if (customElements.get('db-customer-stories')) return;

  class DBCustomerStories extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._controller = new AbortController();
      this._gallery = this.querySelector('.dbcs-gallery');
      this._track = this.querySelector('.dbcs-track');
      this._strip = this._track?.querySelector('.dbcs-strip');
      this._reviewRegion = this.querySelector('.dbcs-reviews');
      this._reviews = Array.from(this.querySelectorAll('[data-dbcs-review]'));
      this._photos = Array.from(this._strip?.querySelectorAll('[data-dbcs-photo]') || []);
      this._photoControl = this.querySelector('.dbcs-motion-photos');
      this._reviewControl = this.querySelector('.dbcs-motion-reviews');
      this._previousControl = this.querySelector('.dbcs-previous');
      this._nextControl = this.querySelector('.dbcs-next');
      this._photoReasons = new Set();
      this._reviewReasons = new Set();
      this._touches = { photos: null, reviews: null };
      this._touchTimers = {};
      this._clones = [];
      this._animation = null;
      this._photoProgress = 0;
      this._photoDuration = 0;
      this._layoutSignature = '';
      this._layoutFrame = null;
      this._editorFrame = null;
      this._reviewIndex = 0;
      this._reviewTimer = null;
      this._reviewStartedAt = 0;
      this._reviewRemaining = this._reviewDuration(0);
      this._userPhotoPaused = false;
      this._userReviewPaused = false;
      this._editorSelected = false;
      this._editorPhoto = false;
      this._offscreen = 'IntersectionObserver' in window;
      this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._reducedMotion = this._motionQuery.matches;
      this._reviewRegion?.setAttribute('aria-live', 'off');
      this._reviews.forEach((review, index) => { review.hidden = index !== 0; });
      this.dataset.reviewIndex = '0';
      this.dataset.enhanced = 'true';
      this._listen();
      this._observe();
      this._syncMotion();
      this._scheduleLayout();
    }

    disconnectedCallback() {
      this._connected = false;
      this._controller?.abort();
      this._intersectionObserver?.disconnect();
      this._resizeObserver?.disconnect();
      this._stopReviewTimer();
      this._animation?.cancel();
      this._animation = null;
      cancelAnimationFrame(this._layoutFrame);
      cancelAnimationFrame(this._editorFrame);
      this._layoutFrame = null;
      this._editorFrame = null;
      Object.values(this._touchTimers || {}).forEach(clearTimeout);
      this._removeClones();
      this._reviews?.forEach(review => { review.hidden = false; });
      if (this._gallery) this._gallery.removeAttribute('data-manual');
      delete this.dataset.enhanced;
      this.dataset.photoRunning = 'false';
      this.dataset.reviewRunning = 'false';
    }

    _on(target, type, callback, options = {}) {
      target?.addEventListener(type, callback, { ...options, signal: this._controller.signal });
    }

    _listen() {
      for (const [region, channel] of [[this._gallery, 'photos'], [this._reviewRegion, 'reviews']]) {
        this._on(region, 'pointerenter', event => {
          if (event.pointerType !== 'touch') this._setReason(channel, 'hover', true);
        }, { passive: true });
        this._on(region, 'pointerleave', event => {
          if (event.pointerType !== 'touch') this._setReason(channel, 'hover', false);
        }, { passive: true });
        this._on(region, 'pointerdown', event => this._touchStart(event, channel), { passive: true });
      }
      this._on(document, 'pointerup', event => this._touchEnd(event, false), { passive: true });
      this._on(document, 'pointercancel', event => this._touchEnd(event, true), { passive: true });
      this._on(this, 'focusin', () => this._syncFocus());
      this._on(this, 'focusout', () => {
        queueMicrotask(() => { if (this._connected) this._syncFocus(); });
      });
      this._on(this._gallery, 'keydown', event => {
        if (event.target !== this._gallery || ![' ', 'Enter'].includes(event.key)) return;
        if (this._reducedMotion) return;
        event.preventDefault();
        this._userPhotoPaused = !this._userPhotoPaused;
        this._syncMotion();
      });
      this._on(this._reviewRegion, 'keydown', event => {
        if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || this._reviews.length < 2) return;
        event.preventDefault();
        this._showReview(this._reviewIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
      });
      this._on(this._photoControl, 'click', () => {
        this._userPhotoPaused = !this._userPhotoPaused;
        this._syncMotion();
      });
      this._on(this._reviewControl, 'click', () => {
        this._userReviewPaused = !this._userReviewPaused;
        this._syncMotion();
      });
      this._on(this._previousControl, 'click', () => this._showReview(this._reviewIndex - 1, true));
      this._on(this._nextControl, 'click', () => this._showReview(this._reviewIndex + 1, true));
      this._on(document, 'visibilitychange', () => this._syncMotion());
      this._on(this._motionQuery, 'change', event => {
        this._reducedMotion = event.matches;
        this._layoutSignature = '';
        this._syncMotion();
        this._scheduleLayout();
      });
      this._on(document, 'shopify:block:select', event => this._selectEditorBlock(event));
      this._on(document, 'shopify:block:deselect', event => {
        if (this._editorSelected && (!event.detail?.blockId || event.detail.blockId === this._editorBlockId)) {
          this._clearEditorSelection();
        }
      });
    }

    _observe() {
      if ('IntersectionObserver' in window) {
        this._intersectionObserver = new IntersectionObserver(entries => {
          this._offscreen = !entries[0]?.isIntersecting;
          this._syncMotion();
        }, { threshold: 0 });
        this._intersectionObserver.observe(this);
      }
      if ('ResizeObserver' in window) {
        this._resizeObserver = new ResizeObserver(() => this._scheduleLayout());
        if (this._gallery) this._resizeObserver.observe(this._gallery);
        if (this._strip) this._resizeObserver.observe(this._strip);
      } else {
        this._on(window, 'resize', () => this._scheduleLayout(), { passive: true });
      }
    }

    _setReason(channel, reason, enabled) {
      const reasons = channel === 'photos' ? this._photoReasons : this._reviewReasons;
      if (enabled) reasons.add(reason);
      else reasons.delete(reason);
      this._syncMotion();
    }

    _syncFocus() {
      const focused = document.activeElement;
      const photosFocused = Boolean(focused && (this._gallery?.contains(focused) || this._photoControl === focused));
      const reviewsFocused = Boolean(focused && (this._reviewRegion?.contains(focused) ||
        [this._reviewControl, this._previousControl, this._nextControl].includes(focused)));
      if (photosFocused) this._photoReasons.add('focus');
      else this._photoReasons.delete('focus');
      if (reviewsFocused) this._reviewReasons.add('focus');
      else this._reviewReasons.delete('focus');
      this._syncMotion();
    }

    _globallyPaused() {
      return !this._connected || document.hidden || this._offscreen || this._reducedMotion || this._editorSelected;
    }

    _syncMotion() {
      if (!this._connected) return;
      const globallyPaused = this._globallyPaused();
      const photosRunning = Boolean(this._animation && !globallyPaused && !this._userPhotoPaused && !this._photoReasons.size);
      if (this._animation) {
        if (photosRunning) this._animation.play();
        else this._animation.pause();
      }
      this.dataset.photoRunning = String(photosRunning);
      const reviewsRunning = this._reviews.length > 1 && !globallyPaused && !this._userReviewPaused && !this._reviewReasons.size;
      if (reviewsRunning) this._startReviewTimer();
      else this._stopReviewTimer();
      this.dataset.reviewRunning = String(reviewsRunning);
      if (this._photoControl) {
        this._photoControl.disabled = this._reducedMotion || !this._photos.length;
        this._photoControl.textContent = this._reducedMotion || this._userPhotoPaused ?
          this.dataset.playPhotos : this.dataset.pausePhotos;
        this._photoControl.setAttribute('aria-pressed', String(this._userPhotoPaused));
      }
      if (this._reviewControl) {
        this._reviewControl.disabled = this._reducedMotion || this._reviews.length < 2;
        this._reviewControl.textContent = this._reducedMotion || this._userReviewPaused ?
          this.dataset.playReviews : this.dataset.pauseReviews;
        this._reviewControl.setAttribute('aria-pressed', String(this._userReviewPaused));
      }
      if (this._previousControl) this._previousControl.disabled = this._reviews.length < 2;
      if (this._nextControl) this._nextControl.disabled = this._reviews.length < 2;
    }

    _scheduleLayout() {
      if (!this._connected || this._layoutFrame) return;
      this._layoutFrame = requestAnimationFrame(() => {
        this._layoutFrame = null;
        if (this._connected) this._layoutPhotos();
      });
    }

    _rememberPhotoProgress() {
      if (this._animation && this._photoDuration > 0 && this._animation.currentTime !== null) {
        this._photoProgress = (Number(this._animation.currentTime) % this._photoDuration) / this._photoDuration;
      }
    }

    _layoutPhotos() {
      if (!this._gallery || !this._track || !this._strip) return;
      const manual = this._reducedMotion || this._editorPhoto || typeof this._track.animate !== 'function';
      this._gallery.dataset.manual = String(manual);
      if (manual) {
        this._rememberPhotoProgress();
        this._animation?.cancel();
        this._animation = null;
        this._removeClones();
        this._layoutSignature = '';
        this._syncMotion();
        return;
      }
      const stripWidth = this._strip.getBoundingClientRect().width;
      const viewportWidth = this._gallery.clientWidth;
      const gap = parseFloat(getComputedStyle(this._track).columnGap) || 0;
      const distance = stripWidth + gap;
      if (!this._photos.length || stripWidth < 1 || viewportWidth < 1) {
        this._rememberPhotoProgress();
        this._animation?.cancel();
        this._animation = null;
        this._removeClones();
        this._layoutSignature = '';
        this._syncMotion();
        return;
      }
      const cloneCount = Math.max(1, Math.ceil((viewportWidth + gap) / distance));
      const speed = Math.min(160, Math.max(8, Number(this.dataset.photoSpeed) || 80));
      const signature = [stripWidth.toFixed(2), viewportWidth, gap, cloneCount, speed].join(':');
      if (signature === this._layoutSignature && this._animation) {
        this._syncMotion();
        return;
      }
      this._rememberPhotoProgress();
      this._animation?.cancel();
      this._removeClones();
      for (let index = 0; index < cloneCount; index += 1) {
        const clone = this._strip.cloneNode(true);
        for (const element of [clone, ...clone.querySelectorAll('*')]) {
          for (const attribute of Array.from(element.attributes)) {
            if (attribute.name === 'id' || attribute.name === 'data-block-id' ||
              attribute.name === 'data-dbcs-photo' || attribute.name.startsWith('data-shopify') ||
              ['aria-labelledby', 'aria-describedby', 'aria-controls'].includes(attribute.name)) {
              element.removeAttribute(attribute.name);
            }
          }
        }
        clone.querySelectorAll('script').forEach(script => script.remove());
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.dataset.dbcsClone = 'true';
        this._track.append(clone);
        this._clones.push(clone);
      }
      this._gallery.scrollLeft = 0;
      this._photoDuration = distance / speed * 1000;
      this._animation = this._track.animate([
        { transform: 'translate3d(0, 0, 0)' },
        { transform: `translate3d(${-distance}px, 0, 0)` }
      ], { duration: this._photoDuration, iterations: Infinity, easing: 'linear' });
      this._animation.pause();
      this._animation.currentTime = this._photoProgress * this._photoDuration;
      this._layoutSignature = signature;
      this._syncMotion();
    }

    _removeClones() {
      this._clones?.forEach(clone => clone.remove());
      this._clones = [];
    }

    _reviewDuration() {
      const configuredSeconds = Number(this.dataset.reviewMinSeconds);
      const seconds = Number.isFinite(configuredSeconds) && configuredSeconds > 0 ? configuredSeconds : 5;
      return Math.min(20, Math.max(2, seconds)) * 1000;
    }

    _startReviewTimer() {
      if (this._reviewTimer !== null) return;
      this._reviewStartedAt = performance.now();
      this._reviewTimer = setTimeout(() => {
        this._reviewTimer = null;
        this._reviewStartedAt = 0;
        if (!this._connected) return;
        if (this._globallyPaused() || this._userReviewPaused || this._reviewReasons.size) {
          this._reviewRemaining = 0;
          this._syncMotion();
          return;
        }
        this._showReview(this._reviewIndex + 1, false);
      }, Math.max(100, this._reviewRemaining));
    }

    _stopReviewTimer() {
      if (this._reviewTimer === null || this._reviewTimer === undefined) return;
      clearTimeout(this._reviewTimer);
      this._reviewTimer = null;
      this._reviewRemaining = Math.max(0, this._reviewRemaining - (performance.now() - this._reviewStartedAt));
      this._reviewStartedAt = 0;
    }

    _showReview(index, manual) {
      if (!this._reviews.length) return;
      this._stopReviewTimer();
      const nextIndex = ((index % this._reviews.length) + this._reviews.length) % this._reviews.length;
      this._reviewRegion?.setAttribute('aria-live', manual ? 'polite' : 'off');
      this._reviews.forEach((review, reviewIndex) => { review.hidden = reviewIndex !== nextIndex; });
      this._reviewIndex = nextIndex;
      this.dataset.reviewIndex = String(nextIndex);
      this._reviewRemaining = this._reviewDuration(nextIndex);
      this._syncMotion();
    }

    _touchStart(event, channel) {
      if (event.pointerType !== 'touch') return;
      clearTimeout(this._touchTimers[channel]);
      this._touches[channel] = { id: event.pointerId, x: event.clientX, y: event.clientY };
      this._setReason(channel, 'touch', true);
    }

    _touchEnd(event, cancelled) {
      for (const channel of ['photos', 'reviews']) {
        const touch = this._touches[channel];
        if (!touch || touch.id !== event.pointerId) continue;
        this._touches[channel] = null;
        if (!cancelled && channel === 'reviews') {
          const horizontal = event.clientX - touch.x;
          const vertical = event.clientY - touch.y;
          if (Math.abs(horizontal) > 48 && Math.abs(horizontal) > Math.abs(vertical) * 1.35) {
            this._showReview(this._reviewIndex + (horizontal < 0 ? 1 : -1), true);
          }
        }
        this._touchTimers[channel] = setTimeout(() => {
          if (this._connected) this._setReason(channel, 'touch', false);
        }, cancelled ? 0 : 1400);
      }
    }

    _selectEditorBlock(event) {
      const id = event.detail?.blockId;
      const reviewIndex = this._reviews.findIndex(review => review.dataset.blockId === id && id);
      const photo = this._photos.find(item => item.dataset.blockId === id && id);
      if (reviewIndex < 0 && !photo) {
        if (this._editorSelected) this._clearEditorSelection();
        return;
      }
      this._editorSelected = true;
      this._editorPhoto = Boolean(photo);
      this._editorBlockId = id;
      if (reviewIndex >= 0) this._showReview(reviewIndex, false);
      this._layoutSignature = '';
      this._syncMotion();
      this._scheduleLayout();
      if (photo && this._gallery) {
        cancelAnimationFrame(this._editorFrame);
        this._editorFrame = requestAnimationFrame(() => {
          if (!this._connected || !this._editorPhoto) return;
          const galleryBox = this._gallery.getBoundingClientRect();
          const photoBox = photo.getBoundingClientRect();
          this._gallery.scrollTo({
            left: this._gallery.scrollLeft + photoBox.left - galleryBox.left - (galleryBox.width - photoBox.width) / 2,
            behavior: 'auto'
          });
        });
      }
    }

    _clearEditorSelection() {
      this._editorSelected = false;
      this._editorPhoto = false;
      this._editorBlockId = null;
      this._layoutSignature = '';
      this._syncMotion();
      this._scheduleLayout();
    }
  }

  customElements.define('db-customer-stories', DBCustomerStories);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbf-founder-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dbf-founder-faq')) {
    customElements.define('dbf-founder-faq', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialize = this.initialize.bind(this);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
        } else {
          this.initialize();
        }
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.note = this.querySelector('[data-dbf-note]');
        this.toggle = this.querySelector('[data-dbf-note-toggle]');
        this.close = this.querySelector('[data-dbf-note-close]');
        if (!this.note || !this.toggle) return;
        this.initialized = true;
        this.setOpen(false);
        this.toggle.hidden = false;
        if (this.close) this.close.hidden = false;
        this.toggle.addEventListener('click', () => {
          this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true');
        });
        if (this.close) {
          this.close.addEventListener('click', () => {
            this.setOpen(false);
            this.toggle.focus({ preventScroll: true });
            const bounds = this.toggle.getBoundingClientRect();
            if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
              this.toggle.scrollIntoView({ block: 'nearest', behavior: 'auto' });
            }
          });
        }
      }

      setOpen(open) {
        this.note.hidden = !open;
        this.toggle.setAttribute('aria-expanded', String(open));
        this.toggle.querySelector('[data-dbf-read-label]').hidden = open;
        this.toggle.querySelector('[data-dbf-close-label]').hidden = !open;
        this.toggle.querySelector('[data-dbf-plus]').hidden = open;
        this.toggle.querySelector('[data-dbf-minus]').hidden = !open;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbf-look-closer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dbf-look-video')) {
    customElements.define('dbf-look-video', class extends HTMLElement {
      connectedCallback() {
        if (this.listenerController) return;
        const video = this.querySelector('video');
        const playButton = this.querySelector('.dbf-look__play');
        if (!video || !playButton) return;
        this.listenerController = new AbortController();
        const options = { signal: this.listenerController.signal };
        video.controls = false;
        playButton.hidden = false;
        const showNativeControls = () => {
          video.controls = true;
          playButton.hidden = true;
        };
        playButton.addEventListener('click', async () => {
          playButton.disabled = true;
          try {
            await video.play();
            showNativeControls();
            if (this.isConnected) video.focus({ preventScroll: true });
          } catch (error) {
            showNativeControls();
            if (this.isConnected) video.focus({ preventScroll: true });
          } finally {
            playButton.disabled = false;
          }
        }, options);
        video.addEventListener('play', showNativeControls, options);
        video.addEventListener('error', showNativeControls, options);
        video.addEventListener('ended', () => {
          video.controls = false;
          playButton.hidden = false;
        }, options);
      }
      disconnectedCallback() {
        this.listenerController?.abort();
        this.listenerController = null;
        const video = this.querySelector('video');
        if (video) {
          video.pause();
          video.controls = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
